/* import __COLOCATED_TEMPLATE__ from './add-domain.hbs'; */
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';
import { closeModal } from 'sh-www/utils/modal-controls';

class AddCompanyDomainModalComponent extends Component {
  @service('state-managers/application') applicationStateManager;
  @service('commands/company-commands') companyCommandService;

  newDomain = '';

  @computed('newDomain','handleSaveTask.isRunning')
  get isSaveDisabled() {
    return !this.newDomain || this.handleSaveTask.isRunning;
  }

  @action
  onTextInputChange(value) {
    this.set('newDomain', value);
  }

  @task
  *handleSaveTask(company, domainName) {
    try {
      yield this.companyCommandService.addDomain(company, domainName);
      yield this.model.onSubmit.perform();

      this.set('newDomain', '');
      closeModal(this);

      this.applicationStateManager.addToast('Saved domain');
    } catch(e) {
      handleErrorResponseWithModal(this, e, `Failed to save ${domainName} as a domain. Please refresh the page and try again.`);
    }
  }

  @action
  handleDismiss() {
    closeModal(this);
  }
}

export default AddCompanyDomainModalComponent;
